export const ViewTokenDataStyle = {
    
  main: {
    color: '#7BA238',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap:' 20px',
  },
  
  labelStyle: {
    backgroundColor: "black",
    color: "white",
    padding: "5px 5px",
    cursor: "pointer",
    borderRadius: "5px",
    fontSize: "14px",
    paddingBottom: "5px",
  },

  iframeStyle: {
    width: "60%", // Use 100% of the parent container's width
    height: "auto", // Automatically adjust height based on content
  },

  contentStyle: {
    background: "gray",
    color: "black",
    fontSize: "12px",
    width: "80%",
  },

  containerStyle: {
    width: "80%",
    height: "auto",
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },

  imageStyle: {
    width: "300px",
    height: "auto",
  },

  containerStyleV: {
    width: "80%",
    height: "auto",
    overflow: "hidden", // Hide any overflow outside the container
  },

  videoStyle: {
    width: "80%", // Set the width of the container
    height: "auto", // Set the height of the container
  },
  
  h1: {
    fontSize: "clamp(1.25rem, 1.0000rem + 1.2500vw, 2.125rem)",
    paddingBottom: "5px",
    paddingTop: "0px" 
  },

  inputIdContainer: {
    fontSize: "14px",
    paddingBottom: "0px",
    paddingTop: "0px"
  },

  tokenSection:{
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: "0.625rem",
  },

  inputIdLabel: {
    fontSize: "clamp(0.75rem, 0.6786rem + 0.3571vw, 1rem)"
  },

  inputContainer: {
    width: "35%",
    minWidth: "300px",
    textAlign: "center",
    padding: "1.25rem 0",
  },

  inputIdTextEdit: {
    fontSize: "14px",
  },

  viewDataButton: {
    fontSize: "14px",
    paddingBottom: "2px",
    marginLeft: "0px",
  },

  foundData: {
    fontSize: "14px",
    paddingBottom: "5px",
    paddingTop: "0px",
  },

  fileFrame: {
    width: "80%",
    fontSize: "12px",
    background: "white",
  },

  foundDataLabel: {
    fontSize: "14px",
    paddingBottom: "5px",
  },

  downloadContainer: {
    display: "inline-block",
    textAlign: "center",
  },

  alertLabel: { fontSize: "12px" },

};